import tw from "tailwind-styled-components";
import { Formik, Field, Form } from "formik";
import { MdClose, MdEdit } from "react-icons/md";
import {
    InputGroup,
    FieldWrappers,
    Label,
    SubmitBtn,
    SideCancelBtn,
    Wrapper,
    ScrollableContent,
    ActionSection,
    CalendarIcon,
    RupeeIcon,
    ModalHeader,
} from "../../Styles/InputStyles";
import { toast } from "react-toastify";
import moment from "moment";
import Config from "../../../Config";
import { UserImage, ProfileSection, UserInfo } from "../../Styles/PageStyles";
import Images from "../../../Images";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { useMutation, useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { capitalizeFirstLetter } from "../../../helpers";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaRegCalendar } from "react-icons/fa";
import { FaCheck } from "react-icons/fa6";
import SelectOptionModal from "../../SelectOptionModal";
import RoomDropdownModal from "./RoomDropdown";

const ChangeRoom = ({
    setIsChangeRoom,
    data,
    selfi,
    property
}) => {
    const navigate = useNavigate();
    const [calendarOpen, setCalendarOpen] = useState(false);
    const user = useSelector((state) => state.UserReducer.user);
    const formikRef = useRef(null);
    const [selectProperty, setSelectProperty] = useState("");
    const [selectRoom, setSelectRoom] = useState("");
    const filteredProperties = property?.filter(prop => prop.id !== 0) || [];
    const [isPropertyModalOpen, setIsPropertyModalOpen] = useState(false);
    const [isRoomModalOpen, setIsRoomModalOpen] = useState(false);

    const propertyOptions = filteredProperties.map(prop => ({
        label: prop.name || prop.propName || `Property ${prop.id}`,
        value: prop.id,
        subLabel: prop.address || prop.location || ""
    }));

    const initialValues = {
        property: "",
        room: "",
        rent: data?.occupancy?.rent || "",
        shiftingDate: "",
        discardDues: false,
    };

    const handleClose = (resetForm) => {
        setIsChangeRoom(false);
    };

    const handlePropertySelect = (selectedPropertyId) => {
        setSelectProperty(selectedPropertyId);
        if (formikRef.current) {
            formikRef.current.setFieldValue("property", selectedPropertyId);
            formikRef.current.setFieldValue("room", "");
        }
        setSelectRoom("");
    };

    const getCurrentPropertyLabel = () => {
        const selectedProp = property?.find(p => p.id === selectProperty);
        return selectedProp ? selectedProp.name || selectedProp.propName : "Select property";
    };

    const handleSelectedRoom = (selectedOption) => {
        setSelectRoom(selectedOption.id);
        if (formikRef.current) {
            formikRef.current.setFieldValue("room", selectedOption.id);
            formikRef.current.setFieldTouched("room", true);
        }
    };

    const fetchListing = async () => {
        if (!selectProperty) return;
        const response = await axios.get(`${Config.apiUrl}/room/active/list/${selectProperty}`, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${user.token}`,
            },
        });
        return response.data;
    };

    const { isLoading, data: roomData, refetch } = useQuery(
        ['roomData', selectProperty],
        fetchListing,
        { enabled: false }
    );

    useEffect(() => {
        if (selectProperty) {
            refetch();
        }
    }, [selectProperty, refetch]);

    const propId = data?.occupancy?.propId;
    const apiUrl = propId === selectProperty
        ? `${Config.apiUrl}/room/switch`
        : `${Config.apiUrl}/property/switch`;

    //------- Change Room/Property -------
    const changeRoomFunction = async (values) => {
        return await axios.post(apiUrl, values, {
            headers: {
                authorization: "Bearer" + " " + user.token,
                "Content-Type": "application/json",
            },
        });
    };

    const changeRoomSuccess = (data) => {
        if (data?.data?.isSuccess === true) {
            toast.success(data?.data?.msg || "Success");
            setIsChangeRoom(false);
            navigate("/tenants/active");
        } else {
            toast.error(data?.data?.msg || "An Error Occured");
        }
    };

    const changeRoomError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: changeRoomLoading, mutate: changeRoomMutate } = useMutation(
        changeRoomFunction,
        {
            onSuccess: changeRoomSuccess,
            onError: changeRoomError,
        }
    );

    const handleSubmit = (values) => {
        if (!values.room) {
            toast.error("Please select a room");
            return;
        }
        if (!values.rent) {
            toast.error("Rent is required");
            return;
        }
        if (!values.property) {
            toast.error("Please select a property");
            return;
        }
        if (!values.shiftingDate) {
            toast.error("Shifting Date is required");
            return;
        }

        changeRoomMutate({
            newRoomId: values.room,
            roomId: data?.occupancy?.roomId,
            tenantId: data?.occupancy?.tenantId,
            rent: Number(values.rent),
            newRent: Number(values.rent),
            newPropId: values.property,
            rentalCycle: data?.occupancy?.rentalCycle,
            shiftingDate: values.shiftingDate,
            discardDues: values.discardDues,
        });
    };

    return (
        <Container>
            <ModalHeader>
                <h1 className="text-white text-lg font-medium">Change Property/Room</h1>
                <button onClick={handleClose}>
                    <MdClose color="white" size={24} />
                </button>
            </ModalHeader>
            <ProfileSection>
                <div className="flex-row flex">
                    <UserImage className='w-11 h-11' src={selfi ? selfi : Images.Avatar} alt={`Avatar for ${data.name}`} />
                    {(data?.kycStatus === 5 || data?.kycStatus === 4) &&
                        <div className="mt-auto rounded-full bg-green-500 h-4 w-4 flex items-center justify-center -ml-2.5">
                            <FaCheck className="text-white" size={10} />
                        </div>
                    }
                </div>
                <UserInfo>
                    <span className="font-medium">{capitalizeFirstLetter(data?.name)}</span>
                    <span className="text-sm text-gray-600">
                        {data?.occupancy?.propName}, {data?.occupancy?.roomNum}, {data?.occupancy?.flatName || data?.floor}
                    </span>
                </UserInfo>
                <DuesContainer>
                    <DuesLabel>Total Dues</DuesLabel>
                    <DuesAmount>₹{data?.totalDues}</DuesAmount>
                </DuesContainer>
            </ProfileSection>

            <div className="px-6 h-full flex flex-col justify-between">
                <Formik
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    innerRef={formikRef}
                    enableReinitialize
                >
                    {({ values, setFieldValue, resetForm }) => (
                        <Form>
                            <ScrollableContent >
                                <Wrapper >
                                    {/* Property Selection Field */}
                                    <InputGroup className="space-y-1">
                                        <Label htmlFor="property">Select Property *</Label>
                                        <FieldWrappers onClick={() => setIsPropertyModalOpen(true)}>
                                            <Field
                                                type="text"
                                                name="propertyDisplay"
                                                id="propertyDisplay"
                                                autoComplete="off"
                                                readOnly
                                                value={getCurrentPropertyLabel()}
                                                className="w-full border-none outline-none bg-transparent cursor-pointer truncate"
                                            />
                                            <MdEdit className="w-4 h-4 text-gray-400 hover:text-gray-600 transition-colors duration-200 flex-shrink-0 mr-2" />
                                        </FieldWrappers>
                                    </InputGroup>

                                    {selectProperty && roomData?.data && roomData.data.length > 0 && (

                                        <><InputGroup className="space-y-1">
                                            <Label htmlFor="room">Select Room *</Label>
                                            <FieldWrappers onClick={() => setIsRoomModalOpen(true)} className="cursor-pointer">
                                                <Field
                                                    type="text"
                                                    name="roomDisplay"
                                                    id="roomDisplay"
                                                    autoComplete="off"
                                                    readOnly
                                                    value={selectRoom ? `${roomData?.data?.find(r => r.id === selectRoom)?.roomNum || ''}` : "Select room"}
                                                    className="w-full border-none outline-none bg-transparent cursor-pointer truncate" />
                                                <MdEdit className="w-4 h-4 text-gray-400 hover:text-gray-600 transition-colors duration-200 flex-shrink-0 mr-2" />
                                            </FieldWrappers>
                                        </InputGroup><RoomDropdownModal
                                                isOpen={isRoomModalOpen}
                                                onClose={() => setIsRoomModalOpen(false)}
                                                title="Select Room"
                                                options={roomData?.data || []}
                                                selectedValue={selectRoom}
                                                onSelect={handleSelectedRoom}
                                                isLoading={isLoading}
                                                searchPlaceholder="Search by room number, floor..." /></>
                                    )}
                                    {selectProperty && (!roomData?.data || roomData.data.length === 0) && (
                                        <div className="text-center py-4 text-gray-500 text-sm">
                                            No available rooms in this property
                                        </div>
                                    )}

                                    {selectRoom && (
                                        <>
                                            <InputGroup className="space-y-1">
                                                <Label htmlFor="rent">Monthly Rent *</Label>
                                                <FieldWrappers>
                                                    <RupeeIcon />
                                                    <Field
                                                        type="text"
                                                        name="rent"
                                                        id="rent"
                                                        className="w-full truncate pl-6"
                                                    />
                                                </FieldWrappers>
                                            </InputGroup>
                                            <InputGroup className="space-y-1">
                                                <Label htmlFor="shiftingDate">Shifting Date *</Label>
                                                <FieldWrappers>
                                                    <DatePicker
                                                        //selected={values.shiftingDate ? new Date(values.shiftingDate) : null}
                                                        selected={values.shiftingDate ? moment(values.shiftingDate, "YYYY-MM-DD").toDate() : null}
                                                        onChange={(date) => {
                                                            setFieldValue("shiftingDate", moment(date).format("YYYY-MM-DD"));
                                                            setCalendarOpen(false);
                                                        }}
                                                        onClickOutside={() => setCalendarOpen(false)}
                                                        onSelect={() => setCalendarOpen(false)}
                                                        open={calendarOpen}
                                                        onInputClick={() => setCalendarOpen(true)}
                                                        dateFormat="yyyy-MM-dd"
                                                        className="cursor-pointer items-center w-full border-none outline-none bg-transparent"
                                                        placeholderText="Select shifting date"
                                                        showIcon
                                                        icon={<FaRegCalendar className="text-gray-400 text-xs mt-0.5" />}
                                                        showPopperArrow={false}
                                                        onFocus={(e) => e.target.blur()}
                                                        wrapperClassName="w-full"
                                                        required
                                                        name="shiftingDate"
                                                        id="shiftingDate"
                                                        autoComplete="off"
                                                        portalId="root-portal"
                                                        popperClassName="react-datepicker-popper"
                                                    />
                                                </FieldWrappers>
                                            </InputGroup>
                                            <InputGroup className="space-y-1">
                                                <Label>
                                                    Manage Previous Dues *
                                                </Label>

                                                <Option
                                                    className={`${values.discardDues
                                                        ? "border-blue-500 bg-blue-100"
                                                        : "border-gray-300"
                                                        }`}
                                                    onClick={() => setFieldValue("discardDues", true)}
                                                >
                                                    <Radio
                                                        className={`${values.discardDues ? "bg-blue-500" : ""}`}
                                                    >
                                                        {values.discardDues && <InnerCircle />}
                                                    </Radio>
                                                    <span className="text-sm ml-3 text-gray-600">
                                                        Delete Previous Dues
                                                    </span>
                                                </Option>

                                                <Option
                                                    className={`${values.discardDues
                                                        ? "border-gray-300"
                                                        : "border-blue-500 bg-blue-100"
                                                        } mt-2`}
                                                    onClick={() => setFieldValue("discardDues", false)}
                                                >
                                                    <Radio
                                                        className={`${!values.discardDues ? "bg-blue-500" : ""}`}
                                                    >
                                                        {!values.discardDues && <InnerCircle />}
                                                    </Radio>
                                                    <span className="text-sm ml-3 text-gray-600">
                                                        Carry Forward
                                                    </span>
                                                </Option>

                                            </InputGroup>
                                        </>
                                    )}
                                </Wrapper>
                            </ScrollableContent>
                            <ActionSection>
                                <SideCancelBtn type="button" onClick={handleClose}>
                                    Cancel
                                </SideCancelBtn>
                                <SubmitBtn
                                    type="submit"
                                    disabled={changeRoomLoading || !values.property || !values.room}
                                >
                                    {changeRoomLoading ? "Submitting..." : "Submit"}
                                </SubmitBtn>
                            </ActionSection>
                        </Form>
                    )}
                </Formik>
            </div>

            <SelectOptionModal
                isOpen={isPropertyModalOpen}
                onClose={() => setIsPropertyModalOpen(false)}
                title="Select Property"
                options={propertyOptions}
                selectedValue={selectProperty}
                onSelect={handlePropertySelect}
                searchPlaceholder="Search properties..."
                showSubLabel={true}
            />

        </Container>
    );
};

const Container = tw.div`bg-white w-full h-full flex flex-col relative`;
const Header = tw.div`flex items-center justify-between bg-[#0078BD] py-4 px-4`;
const DuesContainer = tw.div`ml-auto `;
const DuesLabel = tw.p`text-gray-500 text-sm`;
const DuesAmount = tw.p`text-xl font-semibold`;
const Option = tw.div`p-3 border rounded-lg flex items-center cursor-pointer mt-2`;
const Radio = tw.div`w-5 h-5 flex items-center justify-center rounded-full border`;
const InnerCircle = tw.div`w-3 h-3 bg-white rounded-full`;

export default ChangeRoom;